<template>
  <div class="author-pane">
    <div class="author-mask" :style="authorStyle" >
      <div class="image-border-mask">
        <img class="author-image image grayscale" v-lazy="authorImage" v-if="authorImage"/>
        <svg-default-avater v-else class="author-image image" width="100%" height="100%"></svg-default-avater>
      </div>
    </div>
    <div class="author-info">
      <div v-if="author.title" class="author-list">
        <div class="authors" v-if="authors">
          <div v-for="(author, key) in authors" class="author-name">
            <term-link :tid="author.tid" :title="author.title" :url="author.relative_url" :type="author.type">
              {{author.title}}
            </term-link><br>
          </div>
        </div>
      </div>
      <field-date :node="node"></field-date>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'
import forEach from 'lodash/forEach'
import map from 'lodash/map'

import SvgDefaultAvater from 'static/svg/raw/icon_default_avater.svg'
import FieldDate from 'components/node/fields/Date.vue'
import Section from 'components/mixins/section'
import TermLink from 'components/term/Link'

export default {
  name: 'author-pane',
  props: ['node'],
  mixins: [Section],
  components: {
    FieldDate,
    SvgDefaultAvater,
    TermLink,
  },
  computed: {
    sections() {
      const sections = []
      forEach(get(this, 'node.sections', []), (sectionLineage) => {
        const sectionList = map(sectionLineage, this.$store.getters.term)
        sections.push(sectionList)
      })
      return sections
    },
    authorStyle() {
      return { borderColor: this.sectionColor }
    },
    authors() {
      return map(get(this, 'node.authors', []), this.$store.getters.term)
    },
    author() {
      return this.$store.getters.term(get(this, 'node.authors[0]'))
    },
    authorImage() {
      if (this.authors.length > 1) {
        return false
      }
      return get(this, 'author.images[0].style_500x500')
    },
  },
}
</script>

<style lang="scss" scoped>
.author-pane {
  font-family: $barlow;

  @include respond-to('desktop') {
    align-items: center;
    padding-left: rem-calc(15);
    padding-top: rem-calc(15);
  }
  @include respond-to('mobile') {
    text-align: center;
    margin-top: rem-calc(-41);
  }
}

.author-list {
  color: $oxford-blue;
  font-size: rem-calc(14);
  line-height: rem-calc(16);
  padding-bottom: rem-calc(3);
  a {
    font-weight: bold;
    color: $oxford-blue;
  }
  .authors{
    display: inline-block;
    text-align: left;
    &:before{
      content: 'by ';
    }
    .author-name{
      display: inline;
      padding-top: 5px;
      text-align: left;
      &:nth-child(n+2){
        margin-left: rem-calc(17px);
      }
    }
  }
}

.image-border-mask,
.author-mask {
  overflow: hidden;
  @include respond-to('desktop') {
    width: 57px;
    height: 57px;
  }
  @include respond-to('mobile') {
    width: 76.3px;
    height: 76.3px;
  }
}

.author-mask {
  box-sizing: content-box;
  border-width: rem-calc(3);
  border-style: solid;
  background-color: $pastel-gray;
  overflow: hidden;
  transform: translateZ(0px) rotate(45deg);
  .image {
    transform: rotate(-45deg) translateY(-22px);
  }
  @include respond-to('desktop') {
    .image {
      width: rem-calc(90);
      height: rem-calc(90);
    }
  }
  @include respond-to('mobile') {
    display: inline-block;
    margin-bottom: rem-calc(16);
    .image {
      width: rem-calc(108);
      height: rem-calc(108);
    }
  }
}

.author-info {
  @include respond-to('desktop') {
    margin-left: rem-calc(-15);
    margin-top: rem-calc(16);
    .published-date{
      text-align: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// AuthorPane.vue?60c56d39